import customizeValidator from './customizeValidator';
import createPrecompiledValidator from './createPrecompiledValidator';
export { customizeValidator, createPrecompiledValidator };
export * from './types';
export default customizeValidator();
//# sourceMappingURL=index.js.map